import { render } from "./SolidWasteEfficiency.vue?vue&type=template&id=4d2f0b55"
import script from "./SolidWasteEfficiency.vue?vue&type=script&lang=js"
export * from "./SolidWasteEfficiency.vue?vue&type=script&lang=js"

import "./SolidWasteEfficiency.vue?vue&type=style&index=0&id=4d2f0b55&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__